export function deepClone<T>(data: T): T {
	return JSON.parse(JSON.stringify(data));
}

export function normalizeData<T>(data: T): T {
	if (data === null || data === undefined)
		return data;
	
	if (Array.isArray(data)) {
		for (const item of data) {
			normalizeData(item);
		}
	} else if (typeof data === "object") {
		const obj: any = data;
		const keys = Object.keys(obj);
		for (const key of keys){
			if (key.startsWith("__"))
				delete obj[key];
			else {
				normalizeData(obj[key]);
			}
		}
	}
	
	return data;
}

export function openNewTab(url: string | null) {
	if (url)
		window.open(url, "_blank");
}

/**
 * Takes an array of strings (arr) as its input
 * and returns an object with the values of the array as properties and the indices of those properties as values.
 *
 * for example:
 * input:  ["foo", "bar", "baz"]
 * output: { "foo": 0, "bar": 1, "baz": 2 }
 */
export function generateIndexObject(
	arr: string[]
): {[key: string]: number} {
	return arr.reduce(
		(obj, value, index) => ({...obj, [value]: index}),
		{} as {[key: string]: number});
}
